import { render, staticRenderFns } from "./kathong.vue?vue&type=template&id=2e05e62c&scoped=true&"
import script from "./kathong.vue?vue&type=script&lang=js&"
export * from "./kathong.vue?vue&type=script&lang=js&"
import style0 from "./kathong.vue?vue&type=style&index=0&id=2e05e62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e05e62c",
  null
  
)

export default component.exports